<rt-dropdown
  [style.width.px]="width"
  [style.min-width]="minWidthAttr"
  [style.max-width.px]="maxWidth"
  [style.max-height]="noMaxHeight ? 'none' : null"
  [class.has-sticky-footer]="hasStickyFooter"
  [class.margin-bottom]="!hasStickyFooter"
  #rtDropdown
>
  <ng-content />
</rt-dropdown>
@if (hasStickyFooter) {
  <div class="sticky-footer">
    <ng-template
      [ngTemplateOutlet]="footerTemplate || null"
      [ngTemplateOutletContext]="footerTemplateContext || null"
    />
  </div>
}
